import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "price-section d-flex flex-column pb-10 ga-6",
      attrs: { id: "prices" },
    },
    [
      _c(_setup.PriceHeader, {
        class: { "my-n3": _setup.isSpecialistsOnly },
        attrs: {
          lpu: _setup.context.lpu,
          "town-name": _setup.context.town.name,
          "currency-abbreviation": _setup.context.currency.symbol,
          "hide-title-and-phone": _setup.isSpecialistsOnly,
          "appointment-phone": _setup.appointmentPhone,
          "price-range": _setup.context.price_range,
          "price-range-doctors": _setup.context.price_range_doctors,
          "price-range-mrt": _setup.context.price_range_mrt,
          "price-range-kt": _setup.context.price_range_kt,
          "price-range-uzi": _setup.context.price_range_uzi,
          "price-range-rentgen": _setup.context.price_range_rentgen,
          "price-range-uslugi": _setup.context.price_range_uslugi,
        },
      }),
      _vm._v(" "),
      _setup.hasMedflexApi
        ? [
            _c(
              "div",
              { staticClass: "d-flex flex-column ga-3" },
              [
                _c(_setup.PriceSearch, {
                  attrs: { items: _setup.serviceCategories },
                  on: {
                    "search:text": _setup.searchByText,
                    "search:class": _setup.searchByClass,
                    "search:default": _setup.resetSearch,
                  },
                }),
                _vm._v(" "),
                _setup.hasOnlineSwitch
                  ? _c(_setup.PriceOnlineSwitch, {
                      attrs: { value: _setup.isOnlineOnly },
                      on: { input: _setup.setOnlineOnly },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(_setup.PriceUpdateDate, {
                  attrs: { data: _setup.context.unloaded_price_list_data },
                }),
              ],
              1
            ),
          ]
        : _c(_setup.PriceUpdateDate, {
            attrs: { data: _setup.context.unloaded_price_list_data },
          }),
      _vm._v(" "),
      !_setup.isSpecialistsOnly
        ? _c(
            "div",
            {
              staticClass: "price-section__loader my-n3",
              attrs: { "data-qa": "lpu_page_price_loading" },
            },
            [
              _c(VProgressLinear, {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _setup.isLoading,
                    expression: "isLoading",
                  },
                ],
                staticClass: "price-section__loader-bar",
                attrs: {
                  indeterminate: "",
                  height: "2",
                  color: "var(--lpu-branding-color-primary)",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.PriceCatalog, {
        attrs: {
          "has-medflex-ui": _setup.hasMedflexUi,
          "has-medflex-api": _setup.hasMedflexApi,
          "show-pagination": _setup.showPagination,
          "show-all-button": _setup.showAllButton,
          "is-not-found": _setup.isNotFound,
          "is-enabled-direct": Boolean(
            _setup.context.lpu.appointment_service_direct
          ),
          "hide-group-titles": _setup.hideGroupTitles,
          "service-classes": _setup.displayClasses,
          specialities: _setup.specialities,
          categories: _setup.categories,
          lpu: _setup.context.lpu,
          "lpu-id": _setup.context.lpu.id,
          "town-translit": _setup.context.lpu.town.translit,
          "town-timedelta": _setup.townTimedelta,
          "empty-src": _setup.emptySrc,
          "current-page": _setup.currentPage,
          "page-count": _setup.pageCount,
        },
        on: {
          "show-all": _setup.showAllServices,
          "page-input": _setup.relocatePage,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }